import storeState from "@/store";
import { confirmLogin } from "@/assets/js/common.js";
export function apiUrl() {
  let ishttps = "https:" == document.location.protocol ? true : false;

  let hostname = window.location.hostname;

  let API_BASE_URL = "https://www.kexinnengyuan.com:10073/api"; //默认

  if (ishttps) {
    if (hostname === "app.liangzili.com.cn") {
      API_BASE_URL = "https://app.liangzili.com.cn/api"; //正式环境 APS/HTTPS/TLS
    } else if (hostname === "app.dgmpt.com") {
      API_BASE_URL = "https://app.dgmpt.com/api"; //大光明
    } else {
      API_BASE_URL = "https://app.liangzili.com.cn/api";
    }
  } else {
    if (hostname === "app.liangzili.com.cn") {
      API_BASE_URL = "http://app.liangzili.com.cn/api"; //正式环境
    } else if (hostname === "app.dgmpt.com") {
      API_BASE_URL = "http://app.dgmpt.com/api"; //大光明
    } else if (hostname === "qlt.liangzili.com.cn") {
      API_BASE_URL = "http://qlt.liangzili.com.cn/api"; //公网测试
    } else if (hostname === "demoapp.liangzili.com.cn") {
      API_BASE_URL = "http://demoapp.liangzili.com.cn/api"; //项目演示
    } else {
      API_BASE_URL = "http://192.168.1.18/api"; //内网测试环境
    }
  }

  //API_BASE_URL='http://dgmpt.com:8077/api';

  // API_BASE_URL='http://localhost:6800/api';

  // API_BASE_URL='https://www.kexinnengyuan.com:10073/api';

  //API_BASE_URL='http://192.168.1.10:88/api';
  // API_BASE_URL = 'http://app.liangzili.com.cn/api';

  API_BASE_URL = localStorage.getItem("baseUrl") + "api";

  return API_BASE_URL;
}

export function apiUrl2() {
  //let UPLOAD_URL='https://wwww.dgmpt.com/upload/';

  //let UPLOAD_URL='http://110.41.46.126:8087/upload';

  //let UPLOAD_URL='https://www.67tx.com';

  //let UPLOAD_URL='http://localhost:6800/upload';

  //let UPLOAD_URL='http://www.dgmpt.com:8077/api';

  //let UPLOAD_URL='http://localhost:6800/api';

  let UPLOAD_URL = localStorage.getItem("baseUrl") + "api";

  return UPLOAD_URL;
}

//alert(apiUrl());

export function apiUrlError(ToUrl, LevelType) {
  confirmLogin("", ToUrl, LevelType, new Date());
}

/** APP多版本处理（关于我们aboutus，登录login，电话common.js和user，set ）
 * 0 默认全量通 量子力
   1 智慧龙供
   2 华网电力
   3 艾能聚
   4 电安电力
   5 博创信息
   6 金洲精工
   7 东开智维
   8 景能机电
   9 智慧梅兰
   10 泰维电力
   11 大光明
   12 贵州新电能
   13 超源电力
 * */
export function appType() {
  var APP_TYPE = 11;
  if (storeState.getters.getState("APP_TYPE")) {
    APP_TYPE = storeState.getters.getState("APP_TYPE");
  }

  return Number(APP_TYPE);
}



// WEBPACK FOOTER //
// ./src/router/router.config.js